import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function Printer3dSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("printer3d.title")}</title>
        <meta name="keywords" content={t("printer3d.keywords")} />
        <meta name="description" content={t("printer3d.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#2a2438]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/printer3d-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_15%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#1a1528]/92 via-[#1a1528]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("printer3d.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("printer3d.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("printer3d.knowledgeBase.rootLabel")}
        rootColor="#7c3aed"
        treeTranslationKey="printer3d.knowledgeBase.tree"
        i18nPrefix="printer3d.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="printer3d"
        images={{
          painPoints: "/solutions/printer3d-pain.jpeg",
          solutions: "/solutions/printer3d-solutions.jpeg",
          cta: "/solutions/printer3d-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 25%",
          solutions: "50% 30%",
          cta: "50% 26%",
        }}
      />
    </>
  );
}
